module.exports = __webpack_public_path__ + "static/Intercom-0f80dc3863ae21c8b1927d0b6df5c955.png";